import { render, staticRenderFns } from "./loufengReport.vue?vue&type=template&id=6b121a61&scoped=true&"
import script from "./loufengReport.vue?vue&type=script&lang=js&"
export * from "./loufengReport.vue?vue&type=script&lang=js&"
import style0 from "./loufengReport.vue?vue&type=style&index=0&id=6b121a61&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b121a61",
  null
  
)

export default component.exports